"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInflowPath = exports.getNotiCode = exports.displayProfileImg = exports.getRootClass = exports.destoryNotification = exports.updateNotificationFlag = exports.readNotification = exports.resetNotificationFlag = exports.updateSettingFlag = exports.fetchSettings = exports.fetchNotifications = exports.fetchBadge = void 0;

var query_string_1 = __importDefault(require("query-string"));

var config_1 = require("../constants/config");

var helpers_1 = require("../helpers");

function fetchBadge() {
  return fetch("//api.m.onlive.vn/noti/a/badge?_=".concat(Math.random()), {
    credentials: "include"
  }).then(helpers_1.handleFetchErrors).then(function (response) {
    return response.json();
  });
}

exports.fetchBadge = fetchBadge;

function fetchNotifications(sequence) {
  var url = "//api.m.onlive.vn/noti/a/list";
  return fetch(url, {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: query_string_1.default.stringify({
      from: sequence
    }),
    credentials: "include"
  }).then(helpers_1.handleFetchErrors).then(function (response) {
    return response.json();
  });
}

exports.fetchNotifications = fetchNotifications;

function fetchSettings() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var url = "//api.m.onlive.vn/push/setting/a/getFlagStatus?_=1616995108723";
  return fetch(url, {
    credentials: "include"
  }).then(helpers_1.handleFetchErrors).then(function (response) {
    return response.json();
  });
}

exports.fetchSettings = fetchSettings;

function updateSettingFlag(flags) {
  return fetch("//api.m.onlive.vn/push/setting/a/updateFlag", {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: query_string_1.default.stringify({
      set_flag: flags
    }),
    credentials: "include"
  }).then(helpers_1.handleFetchErrors).then(function (response) {
    return response.json();
  });
}

exports.updateSettingFlag = updateSettingFlag;

function resetNotificationFlag() {
  return fetch("//api.m.onlive.vn/push/setting/a/getResetFlagStatus", {
    credentials: "include"
  }).then(helpers_1.handleFetchErrors).then(function (response) {
    return response.json();
  });
}

exports.resetNotificationFlag = resetNotificationFlag;

function readNotification(sequence) {
  return fetch("//api.m.onlive.vn/noti/a/updateNoti", {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: query_string_1.default.stringify({
      actionType: "read",
      sequence: sequence
    }),
    credentials: "include"
  }).then(helpers_1.handleFetchErrors).then(function (response) {
    return response.json();
  });
}

exports.readNotification = readNotification;

function updateNotificationFlag(actionType, sequence) {
  return fetch("//api.m.onlive.vn/noti/a/updateNoti", {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: query_string_1.default.stringify({
      actionType: actionType,
      sequence: sequence
    }),
    credentials: "include"
  }).then(helpers_1.handleFetchErrors).then(function (response) {
    return response.json();
  });
}

exports.updateNotificationFlag = updateNotificationFlag;

function destoryNotification(sequence) {
  return fetch("//api.m.onlive.vn/noti/a/updateNoti", {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: query_string_1.default.stringify({
      actionType: "delete",
      sequence: sequence
    }),
    credentials: "include"
  }).then(helpers_1.handleFetchErrors).then(function (response) {
    return response.json();
  });
}

exports.destoryNotification = destoryNotification;

var getRootClass = function getRootClass() {
  var szNotiType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var szThumbnail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var szFilename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var bReadFlag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var szRootClass = "";

  switch (szNotiType) {
    // VOD 썸네일 노출 영역
    case "F03":
    case "F04":
    case "F05":
    case "A02":
    case "A05":
    case "A08":
    case "A10":
    case "A13":
    case "B03":
    case "B04":
    case "B07":
    case "S02":
    case "S03":
    case "S10":
    case "S12": // 게시글 대표 썸네일 노출 영역

    case "F02":
    case "F12":
    case "A01":
    case "A04":
    case "A07":
    case "A09":
    case "A12":
    case "B02":
      if (szThumbnail != "" || szFilename != "") {
        szRootClass += "photo ";
      }

      break;
  }

  if (bReadFlag) {
    szRootClass += "unlead "; // 왜 unlead일까...
  }

  return szRootClass;
};

exports.getRootClass = getRootClass;
/**
 * 프로필 이미지
 * @param szUserId
 * @returns
 */

var displayProfileImg = function displayProfileImg() {
  var szUserId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  if (szUserId != "") {
    var szFolder = szUserId.substring(0, 2);
    return "".concat(config_1.BJ_PROFILE_URL, "/LOGO/").concat(szFolder, "/").concat(szUserId, "/").concat(szUserId, ".jpg");
  } else {
    return "".concat(config_1.RES_URL, "/images/afmain/img_thumb_profile.gif");
  }
};

exports.displayProfileImg = displayProfileImg;

var getNotiCode = function getNotiCode(type) {
  var noti_code = "";

  switch (type) {
    case "F01":
      noti_code = "favorite_broad";
      break;

    case "F21":
      noti_code = "favorite_banner";
      break;

    case "F03":
      noti_code = "favorite_ucc";
      break;

    case "F02":
    case "F12":
      noti_code = "favorite_content";
      break;

    case "F06":
      noti_code = "favorite_guestbook";
      break;

    case "F11":
      noti_code = "favorite_bj_message";
      break;

    case "A01":
    case "A02":
    case "A03":
    case "C11":
    case "C21":
    case "C31":
      noti_code = "myaction_p_comment";
      break;

    case "A04":
    case "A05":
    case "C14":
    case "C24":
    case "C34":
      noti_code = "myaction_c_comment";
      break;

    case "A07":
    case "A08":
    case "A09":
    case "A10":
    case "A12":
    case "A13":
    case "C17":
    case "C27":
    case "C37":
    case "C19":
    case "C29":
    case "C39":
      noti_code = "myaction_post_like";
      break;

    case "A11":
      noti_code = "myaction_note";
      break;

    case "B02":
      noti_code = "station_content";
      break;

    case "B06":
      noti_code = "station_guestbook";
      break;

    case "B03":
    case "B04":
    case "B07":
      noti_code = "station_ucc";
      break;

    case "S01":
    case "S08":
    case "S02":
    case "S03":
    case "S04":
      noti_code = "item_starballoon";
      break;

    case "S05":
    case "S06":
      noti_code = "item_sticker";
      break;

    case "S07":
      noti_code = "item_chocolate";
      break;

    case "S09":
    case "S10":
    case "S16":
      noti_code = "item_adballoon";
      break;

    case "S11":
    case "S12":
    case "S13":
    case "S14":
      noti_code = "item_subscribe";
      break;

    case "S15":
      noti_code = "item_ticket";
      break;
  }

  return noti_code;
};

exports.getNotiCode = getNotiCode;

var getInflowPath = function getInflowPath(type) {
  var noti_code = "";

  switch (type) {
    case "F01":
      noti_code = "favorite_broad";
      break;

    case "F21":
      noti_code = "favorite_banner";
      break;

    case "F03":
      noti_code = "favorite_ucc";
      break;

    case "F02":
    case "F12":
      noti_code = "favorite_content";
      break;

    case "F06":
      noti_code = "favorite_guestbook";
      break;

    case "F11":
      noti_code = "favorite_bj_message";
      break;

    case "A01":
    case "A02":
    case "A03":
      noti_code = "myaction_p_comment";
      break;

    case "A04":
    case "A05":
      noti_code = "myaction_c_comment";
      break;

    case "A07":
    case "A08":
    case "A09":
    case "A10":
    case "A12":
    case "A13":
      noti_code = "myaction_post_like";
      break;

    case "A11":
      noti_code = "myaction_note";
      break;

    case "B02":
      noti_code = "station_content";
      break;

    case "B06":
      noti_code = "station_guestbook";
      break;

    case "B03":
    case "B04":
    case "B07":
      noti_code = "station_ucc";
      break;

    case "S01":
    case "S08":
    case "S02":
    case "S03":
    case "S04":
      noti_code = "item_starballoon";
      break;

    case "S05":
    case "S06":
      noti_code = "item_sticker";
      break;

    case "S07":
      noti_code = "item_chocolate";
      break;

    case "S09":
    case "S10":
    case "S16":
      noti_code = "item_adballoon";
      break;

    case "S11":
    case "S12":
    case "S13":
    case "S14":
      noti_code = "item_subscribe";
      break;

    case "S15":
      noti_code = "item_ticket";
      break;

    default:
      break;
  }

  return noti_code;
};

exports.getInflowPath = getInflowPath;